/* eslint-disable react/prop-types */
import React from 'react';
import clsx from 'clsx';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import CloseIcon from '@material-ui/icons/Close';

import { MODAL_SIZE } from 'components/Modal';
import { Box } from '@material-ui/core';
import classes from './Base.module.scss';

const BaseModal = (props) => {
  const {
    children,
    className = {},
    open,
    handleClose,
    title,
    renderTitle,
    footer,
    size = MODAL_SIZE.NORMAL,
    titleSmall,
    hideTitleBorder,
    ...other
  } = props;
  const { classRoot, classTitle, classContent, classAction } = className;
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='base-dialog-title'
      aria-describedby='base-dialog-description'
      className={clsx(
        classes.baseModal,
        {
          [classes.small]: size === 'small',
          [classes.normal]: size === 'normal',
          [classes.large]: size === 'large',
        },
        classRoot
      )}
      disableBackdropClick
      {...other}>
      <DialogTitle
        id='base-dialog-title'
        disableTypography
        className={clsx(classes.title, {
          [classes.titleSmall]: titleSmall,
          [classes.hideTitleBorder]: hideTitleBorder,
        },classTitle)}>
        <Box className={classes.titleWrapper} display='flex'>
          {renderTitle ? renderTitle() : <h5>{title}</h5>}

          <div className={classes.closeIcon}>
            <CloseIcon onClick={handleClose} />
          </div>
        </Box>
      </DialogTitle>
      <DialogContent className={clsx(classes.content, classContent)}>
        <div id='base-dialog-description'>{children}</div>
      </DialogContent>
      {footer && (
        <DialogActions className={clsx(classes.action, classAction)}>{footer}</DialogActions>
      )}
    </Dialog>
  );
};

export default BaseModal;
